import { render, staticRenderFns } from "./partnerAdressesBox.vue?vue&type=template&id=4d0e0247&"
import script from "./partnerAdressesBox.vue?vue&type=script&lang=ts&"
export * from "./partnerAdressesBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports